angular.module('app.shared.dataTransformers.clockTimeTransformer', [])
  .factory('app.shared.dataTransformers.clockTimeTransformer', [
    '$filter',
    function ($filter) {
      "use strict";

      let service = {
        secondsToClockTime: (longSeconds) => {
          let hours, minutes, seconds;
          hours = Math.floor((longSeconds / 60) / 60);
          minutes = Math.floor((longSeconds / 60) - (hours * 60));
          seconds = Math.floor(longSeconds - (minutes * 60) - ((hours * 60) * 60));

          return {
            hour: (hours ? hours : 0),
            minute: (minutes ? minutes : 0),
            second: (seconds ? seconds : 0),
          };
        },
        clockTimeToSeconds: (clockTime) => {
          let seconds = 0;

          if (clockTime.hour) {
            seconds += clockTime.hour * 3600;
          }
          if (clockTime.minute) {
            seconds += clockTime.minute * 60;
          }
          if (clockTime.second) {
            seconds += clockTime.second * 1;
          }

          return seconds;
        },
        stringToSeconds: (stringTime) => {
          let arrTime = stringTime.toString().split(':');
          let isValid = true;
          let hour = 0;
          let minute = 0;
          let second = 0;

          switch (arrTime.length) {
            case 3:
              hour = parseInt(arrTime[0]);
              minute = parseInt(arrTime[1]);
              second = parseInt(arrTime[2]);
              break;
            case 2:
              hour = 0;
              minute = parseInt(arrTime[0]);
              second = parseInt(arrTime[1]);
              break;
            default:
              isValid = false;
              break;
          }

          if (isValid) {
            if (!isNaN(hour) && !isNaN(minute) && !isNaN(second)) {
              return second + (minute * 60) + (hour * 3600);
            }
          }

          return null;
        },
        secondsToString: (seconds, format) => {
          let clockTime = service.secondsToClockTime(seconds);

          switch (format) {
            case 'mm:ss':
              let minute = (clockTime.hour * 60) + clockTime.minute;
              return $filter('left_pad')(minute, 2)
                + ':' + $filter('left_pad')(clockTime.second, 2);
              break;
            default:
              return clockTime.hour
                + ':' + $filter('left_pad')(clockTime.minute, 2)
                + ':' + $filter('left_pad')(clockTime.second, 2);
              break;
          }
        },
        clockTimeToString: (clockTime) => {
          let stringTime = '';

          stringTime += clockTime.hour * 3600;
          stringTime += ':' + clockTime.minute * 60;
          stringTime += ':' + clockTime.second;

          return stringTime;
        },
        formatUnit: (unit) => {
          if (unit || parseInt(unit) === 0) {
            return $filter('left_pad')(unit, 2);
          }
        }

      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/dataTransformers/clockTimeTransformer.js